import { usePageTitle } from "../../../../../shared/hooks/usePageTitle";
import { PageHead, PageShell } from "../../components/PageShell";
import { useTranslation } from "../../i18n/useTranslation";

// Anything that is neither the root, nor under /a, nor a single root segment
// that could be a slug.
//
// A grammar-legal root segment routes to Profile, which does its own
// resolution — an unknown slug is Profile's UNAVAILABLE state, not this. So
// reaching here means the SHAPE of the URL was wrong, not the name.
/*
 * Web v2's page shape, with this surface's own words. Web v2 · 06 draws its
 * 404 for app.uselura.com, whose visitors arrive from email links; here the
 * realistic arrival is a mistyped booking link, so the hint says what a
 * booking link looks like rather than pointing at the app.
 */
function NotFound() {
  const { t } = useTranslation();
  usePageTitle(t("notFound.title"));

  return (
    <PageShell testId="not-found">
      <PageHead title={t("notFound.title")} sub={t("notFound.body")} />

    </PageShell>
  );
}

export default NotFound;
